module.exports = __webpack_public_path__ + "static/media/LocationPin.a66e923c.svg";